import React, { useState, useEffect } from 'react';
import { getSettings } from '../../services/SettingsService';
import { PrivatePageLayout, PageHeader, PageCard } from '../../components/PrivatePage';

function TelegramChat() {
    const [url, setUrl] = useState('');

    useEffect(() => {
        getSettings()
            .then((settings) => setUrl(`https://api.telegram.org/bot${settings.telegramToken}/getUpdates`))
            .catch((err) => console.error(err));
    }, []);

    return (
        <PrivatePageLayout width="full">
            <PageHeader
                eyebrow="Admin"
                title="Telegram"
                subtitle="Inspect Telegram bot updates for this environment."
            />
            <PageCard>
                <iframe src={url} title="Telegram Chats" width="100%" height="640" style={{ border: 0 }} />
            </PageCard>
        </PrivatePageLayout>
    );
}

export default TelegramChat;
